import React from "react";
import classNames from "classnames";
import ClipLoader from 'react-spinners/ClipLoader';
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import {Button} from "reactstrap";

/**
 * Records a payment against an open invoice. Submitted as a nested create to
 * PUT /invoices/[parent]/payments via the framework Object submit (parent prop).
 */
class InvoicePayment extends Framework.Components.Object {
	constructor(props) {
		super(props, props.paymentModel || Types.Invoices_Payments._name);
	}

	componentDidMount() {
		this.setState({
			method: this.state.method || 'cash',
			amount: this.state.amount || (this.props.remaining != null ? parseFloat(this.props.remaining).toFixed(2) : "0.00"),
		});
	}

	setMethod = (method) => {
		this.setState({method});
	};

	handleAmountUpdate = (name, value, property) => {
		const parsed = parseFloat(value);
		if (!isNaN(parsed) && parsed < 0) {
			value = "0.00";
		}
		this.handleTextFieldPropertyUpdate(name, value, property);
	};

	form = () => {
		let properties = this.model.properties;
		let object = this.state;
		const method = object.method || 'cash';
		const remaining = this.props.remaining != null ? parseFloat(this.props.remaining) : null;

		return (
			<div>
				<fieldset>
					<h4 className="section-title">Receive Payment</h4>
					{remaining != null && !isNaN(remaining) &&
						<p style={{marginBottom: 12}}><b>Remaining Balance:</b> ${remaining.toFixed(2)}</p>}
					<div className={"row"}>
						<div className={"col"}>
							<div className={"form-group"}>
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									object={object.registers}
									value={object.register}
									error={object.register_error}
									model={Types.Registers._name}
									property={properties.register}
									label={'Register'}
									update={this.handleSelectPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"col"}>
							<div className={'form-group'}>
								<Framework.Elements.DollarAmount
									name={"amount"}
									value={object.amount}
									error={object.amount_error}
									label={"Amount"}
									property={properties.amount}
									update={this.handleAmountUpdate}
									margin={"dense"}
								/>
							</div>
						</div>
					</div>
					<div className={"row form-group"}>
						<div className={"col"}>
							<b>Payment Method</b>
							<div style={{display: 'flex', flexDirection: 'row', gap: 5, paddingTop: 5}}>
								<Button
									style={{ backgroundColor: method === 'cash' ? '#16a34a' : '#a9a9a9', borderColor: method === 'cash' ? '#16a34a' : '#a9a9a9' }}
									onClick={() => this.setMethod('cash')}
									size={"sm"}
								>
									<i className="fa fa-money"/>&nbsp;&nbsp;Cash
								</Button>
								<Button
									style={{ backgroundColor: method === 'other' ? '#16a34a' : '#a9a9a9', borderColor: method === 'other' ? '#16a34a' : '#a9a9a9' }}
									onClick={() => this.setMethod('other')}
									size={"sm"}
								>
									<i className="fa fa-credit-card"/>&nbsp;&nbsp;Other
								</Button>
								{this.props.rootState && this.props.rootState.allow_zelle &&
								<Button
									color={method === 'zelle' ? 'primary' : 'secondary'}
									onClick={() => this.setMethod('zelle')}
									size={"sm"}
								>
									<i className="fa fa-money"/>&nbsp;&nbsp;Zelle
								</Button>}
							</div>
						</div>
					</div>
					<div className={'row'}>
						<div className={'col'}>
							<div className={"form-group"}>
								<Framework.Elements.TextField
									name={"notes"}
									label={"Notes"}
									value={object.notes}
									error={object.notes_error}
									property={properties.notes}
									update={this.handleTextFieldPropertyUpdate}
									multiline={true}
								/>
							</div>
						</div>
					</div>
				</fieldset>
				<div className={classNames("loader", {'active': this.state.loading})}>
					<ClipLoader color={"#4A4A4A"} loading={this.state.loading}/>
				</div>
			</div>
		);
	}
}

export default Framework.Components.withRootState(InvoicePayment);
